import { render, staticRenderFns } from "./DocumentManagement.vue?vue&type=template&id=763b1358&"
import script from "./DocumentManagement.vue?vue&type=script&lang=js&"
export * from "./DocumentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports